import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './address-mercury.actions';
import { AddressesMercuryState } from '../shared/interfaces';
import { UserAddressSearchSuccessArgs } from '@lentau/address/shared/interfaces';

export const storeFeatureKey = 'address-mercury';

export const initialState: AddressesMercuryState = {
  data: null,
  loading: false,
};

// eslint-disable-next-line @typescript-eslint/typedef
const addressMercuryReducer = createReducer(
  initialState,

  on(actions.userMercuryAddressSearch, (state) => ({ ...state, loading: true })),
  on(actions.userMercuryAddressSearchFail, (state) => ({ ...state, loading: false })),
  on(actions.userMercuryAddressSearchSuccess, (state, { addresses }: UserAddressSearchSuccessArgs) => ({
    ...state,
    data: [...addresses],
    loading: false,
  }))
);

export function reducer(state: AddressesMercuryState, action: Action) {
  return addressMercuryReducer(state, action);
}
